import { sendGAEvent } from "@next/third-parties/google";
import posthog from "posthog-js";

type EventParams = Record<string, string | number | boolean | undefined>;

const pathPrefix: { [path: string]: string } = {
  "^\/?$": "home_",
  "^\/request\/?$": "inquiry_",
  "^\/service\/?$": "service_",
  "^\/pricing\/?$": "pricing_",
  "^\/blog\/?$": "blog_",
  "^\/blog\/.*": "blog_post_",
};

/**
 * GA4 + PostHog 동시 이벤트 전송
 */
export function trackEvent(eventName: string, path: string, params?: EventParams) {
  const cleanParams = params ? Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined)) : undefined;

  let prefix = Object.keys(pathPrefix).find((p) => new RegExp(p).test(path));
  prefix = prefix && pathPrefix[prefix];
  console.log();

  // GA4 direct dispatch via gtag.js
  if (typeof window !== "undefined") {
    sendGAEvent("event", `${prefix ?? ""}${eventName}`, cleanParams ?? {});
  }

  // PostHog
  if (posthog.__loaded) {
    posthog.capture(eventName, cleanParams);
  }
}
